<template>
  <div class="notification">
    <b-dropdown-item class="dropdown-avatar-item">
      <router-link :to="senderLink" v-if="senderAvatar"><img :src="senderAvatar" class="avatar"></router-link>
    </b-dropdown-item>
    <div class="body">
      <div class="header">
        <div class="who" v-if="senderName">
          <b-dropdown-item>
            <router-link :to="senderLink">{{ senderName }}</router-link>
          </b-dropdown-item>
        </div>
        <div class="when">
          {{ when }}
        </div>
      </div>
      <div class="content" v-if="feedUpdateType === 'video'">
        published video
        <b-dropdown-item>
          <router-link :to="{name: 'video-detail', params: {id: content.song.id}}">{{ content.song.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="feedUpdateType === 'album'">
        published album
        <b-dropdown-item>
          <router-link :to="{name: 'album-detail', params: {id: content.album.id}}">{{ content.album.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="feedUpdateType === 'live'">
        announced live stream
        <b-dropdown-item>
          <router-link :to="{name: 'artist-live-stream-detail', params: {artistId: content.artist.id, liveId: content.live_event.id}}">{{ content.live_event.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="type === 'live-cancel'">
        cancelled live stream {{ content.title }}
      </div>
      <div class="content" v-else-if="type === 'live-invite'">
        invited you to
        <b-dropdown-item>
          <router-link :to="{name: 'artist-live-stream-detail', params: {artistId: content.artist.id, liveId: content.id}}">{{ content.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="type === 'live-upcoming'">
        starts live stream
        <b-dropdown-item>
          <router-link :to="{name: 'artist-live-stream-detail', params: {artistId: content.artist.id, liveId: content.id}}">{{ content.title }}</router-link>
        </b-dropdown-item>
        {{ liveStreamStart }}
      </div>
      <div class="content" v-else-if="type === 'live-block'">
        has blocked you from
        <b-dropdown-item>
          <router-link :to="{name: 'artist-live-stream-detail', params: {artistId: content.artist.id, liveId: content.id}}">{{ content.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="type === 'purchase-takedown'">
        video
        <b-dropdown-item>
          <router-link :to="{name: 'video-detail', params: {id: content.id}}">{{ content.title }}</router-link>
        </b-dropdown-item>
        was taken down
      </div>
      <div class="content" v-else-if="isArtist && type === 'booking'">
        booked
        <b-dropdown-item>
          <router-link :to="{name: 'artist-live-stream', params: {id: content.live_event.id}}">{{ content.live_event.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="isArtist && type === 'album-purchase'">
        purchased
        <b-dropdown-item>
          <router-link :to="{name: 'album-detail', params: {id: content.album.id}}">{{ content.album.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="isArtist && type === 'song-purchase'">
        purchased
        <b-dropdown-item>
          <router-link :to="{name: 'video-detail', params: {id: content.song.id}}">{{ content.song.title }}</router-link>
        </b-dropdown-item>
      </div>
      <div class="content" v-else-if="isArtist && type === 'song-takedown'">
        <b-dropdown-item>
          <router-link :to="{name: 'video-detail', params: {id: content.id}}">{{ content.title }}</router-link>
        </b-dropdown-item>
        was taken down
      </div>
      <div class="content" v-else-if="isArtist && type === 'donation'">
        donated ${{ content.amount }}
      </div>

      <div class="content" v-else>
        {{ getMessage }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .notification {
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    align-items: start;
    min-width: 240px;
    margin-bottom: 5px;

    .dropdown-item {
      padding: 0 !important;
      display: inline !important;
    }

    .dropdown-avatar-item {
      padding: 0 !important;
      width: 29px !important;
    }

    img.avatar {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      margin-right: 5px;
    }

    .body {
      flex: 1;
      flex-basis: content;

      .header {
        display: flex;

        .who {
          flex-grow: 1;
        }

        .when {
          flex-grow: 1;
          text-align: right;
          color: $steel;
        }
      }
      .content {
        color: $white;
      }
    }
  }
</style>

<script>
import moment from '@/utils/moment'
import { mapGetters } from 'vuex'
import { profileHelpers } from '@/store/helpers'

export default {
  name: 'Notification',
  props: {
    notification: Object,
    artistMode: Boolean
  },
  computed: {
    type () {
      return this.notification.type
    },
    content () {
      return this.notification.content
    },
    feedUpdateType () {
      if (this.type !== 'feed-update') return null
      if (this.content.song) return 'video'
      if (this.content.live_event) return 'live'
      if (this.content.album) return 'album'
    },
    when () {
      return moment(this.notification.created_at).fromNow()
    },
    liveStreamStart () {
      if (this.type !== 'live-upcoming') return ''
      return moment(this.content.start).fromNow()
    },
    senderName () {
      if (this.content.artist) return this.content.artist.name
      if (this.content.fan) return this.displayName(this.content.fan)
      return ''
    },
    senderLink () {
      if (this.content.artist) return {name: 'artist-about', params: {artistId: this.content.artist.id}}
      if (this.content.fan) return {name: 'fan-profile', params: {id: this.content.fan.id}}
      return null
    },
    senderAvatar () {
      if (this.content.artist) return this.content.artist.avatar_image
      if (this.content.fan) return this.avatarImage(this.content.fan)
      return null
    },
    getMessage () {
      if (this.type === 'feed-update') {
        return this.notification.content.text.substr(0, 200)
      }
      return ''
    },
    ...mapGetters('profile', ['isArtist'])
  },
  methods: {
    ...profileHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Notification.vue